import type { NextPage } from 'next'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const PlantingProjectsPage: NextPage = () => {
  return <SanityContentPage slug='planting-projects' showBreadcrumbs={false} />
}

export default PlantingProjectsPage
